import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-socials',
  templateUrl: './block-socials.component.html',
  styleUrls: ['./block-socials.component.css']
})
export class BlockSocialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
